import {
  createTheme,
  ThemeProvider,
  Container,
  Paper,
  Typography,
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Divider,
  Grid,
  Dialog,
  DialogTitle,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Recaptcha from "react-google-recaptcha";
import { GridCloseIcon } from "@mui/x-data-grid";
import logo from "../../assets/img/logo1.png";
import { useForm } from "react-hook-form";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  SIGNIN_FORM_VALIDATION,
  RESETPASSWORD_EMAIL__VALIDATION,
} from "../../utils/Validation";
import { Link, useLocation } from "react-router-dom";
import {
  ValidateEmailWhileLoginService,
  LoginService,
  GenerateTokenService,
  GenerateTokenUserOnBoard,
  SendOtpService,
} from "../../services/LoginService.jsx";
import { RoleListingService } from "../../services/UserOnboardingService";
import useGlobalState from "../../Context";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { useNavigate } from "react-router-dom";
import {
  setSignIn,
  setSpareAccessRights,
  setTechnicalDocAccessRights,
  setAdvisoriesAccessRights,
  setRollList,
} from "../../reducer/action";
import {
  roleAccessForSpare,
  roleAccessForTechnicalDoc,
  roleAccessForAdvisories,
} from "../../utils/RoleAccessByLoginUser";
// import { isValid } from "date-fns";
const theme = createTheme();
const SignIn = () => {
  const site_Key = process.env.REACT_APP_SITE_KEY;
  const [, dispatch] = useGlobalState();
  const navigate = useNavigate();
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordField, setShowPasswordField] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [email, setEmail] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [loginResp, setLoginResponse] = useState();
  const [forceLogin, setForceLogin] = useState(false);
  const [captValue, setCaptValue] = useState();
  const [isCaptchaCheck, setIsCaptchaCheck] = useState(false);
  const location = useLocation();
  const formOption = {
    resolver: yupResolver(
      showPasswordField
        ? SIGNIN_FORM_VALIDATION
        : RESETPASSWORD_EMAIL__VALIDATION
    ),
  };
  const {
    register,
    handleSubmit,
    getFieldState,
    formState: { errors, isDirty, isValid },
    reset,
  } = useForm(formOption);

  const onBackClick = () => {
    setShowPasswordField(false);
    setShowForgotPassword(false);
    reset({
      email: "",
    });
  };

  //handle duplicate login session
  const handleLoginSession = () => {
    setOpenDialog(true);
  };
  const fetchRoleList = async () => {
    try {
      const requestObject = {
        pageNumber: 0,
        pageSize: 200,
        filterSearch: null,
        active: 0,
        sortDirection: "ASC",
        sortBy: "name",
      };
      const roleListingResponse = await RoleListingService(requestObject);
      if (roleListingResponse.statusCode === 6) {
        let roleArrayList = roleListingResponse.data.content.map((value) => {
          return value.name;
        });
        dispatch(setRollList(roleArrayList));
        navigate("/notifications");
      } else {
        showNotification("Error", roleListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleContinueLogin = () => {
    setOpenDialog(false);
    setForceLogin(true);
    setEmail(loginResp?.data?.email);
    if (loginResp.data?.password) {
      setShowPasswordField(true);
    } else {
      navigate("/resetPassword");
    }
    if (!loginResp.data.rilUser) {
      setShowForgotPassword(true);
    }
  };
  const onProceedClick = async (data) => {
    try {
      // console.log('tst',process.env.REACT_APP_BASE_URL === "https://rstp.ril.com" ? 'prod':'other')
      setLoading(true);
      localStorage.setItem("email", data.email.toLowerCase());
      const response = await ValidateEmailWhileLoginService(
        data?.email.toLowerCase()
      );
      if (response.statusCode === 6) {
        if (response.data?.loggedIn && !response.data.rilUser) {
          handleLoginSession();
          setLoginResponse(response);
        } else {
          setForceLogin(false);
          setLoginResponse();
          setEmail(data?.email);
          if (response.data?.password) {
            setShowPasswordField(true);
          } else {
            navigate("/resetPassword");
            onUserOnboard(data?.email);
          }
          if (!response.data.rilUser) {
            setShowForgotPassword(true);
          }
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  const onSignInClick = async (data) => {
    try {
      const param = {
        username: data.email.toLowerCase(),
        password: window.btoa(data?.password),
        forcedLogin: forceLogin,
      };
      setLoading(true);

      const response = await LoginService(param, captValue);
      if (response?.statusCode === 6) {
        let responseOtp = null;
        try {
          responseOtp = await SendOtpService(data.email.toLowerCase(),response.data.randomToken);
           if (responseOtp?.statusCode === 6) {

              navigate("/otp", {
                state: {
                  loginResponse: response,
                  email: data.email,
                  username: data.email.toLowerCase(),
                  password: window.btoa(data?.password),
                  forcedLogin: forceLogin,
                  captValue,
                  responseOtp,
                },
              });
            }
            else {
              showNotification("Error", responseOtp.message, "error");
            }
        } catch (err) {
          console.error("OTP Error:", err);
          showNotification(
            "Warning",
            "Authenticated successfully, but OTP could not be sent. Please try again.",
            "warning"
          );
        }
        

        // dispatch(setSignIn(response));
        // localStorage.setItem("partTypeListItem", "");
        // const sparePermissionObj = roleAccessForSpare(response?.authorities);
        // const technicalDocPermissionObj = roleAccessForTechnicalDoc(
        //   response?.authorities
        // );
        // const advisoriesPermissionObj = roleAccessForAdvisories(
        //   response?.authorities
        // );
        // dispatch(
        //   setSpareAccessRights({
        //     read: sparePermissionObj.readPermission,
        //     write: sparePermissionObj.writePermission,
        //     addDelete: sparePermissionObj.addDeletePermission,
        //   })
        // );
        // dispatch(
        //   setTechnicalDocAccessRights({
        //     read: technicalDocPermissionObj.readPermission,
        //     write: technicalDocPermissionObj.writePermission,
        //     addDelete: technicalDocPermissionObj.addDeletePermission,
        //   })
        // );
        // dispatch(
        //   setAdvisoriesAccessRights({
        //     read: advisoriesPermissionObj.readPermission,
        //     write: advisoriesPermissionObj.writePermission,
        //     addDelete: advisoriesPermissionObj.addDeletePermission,
        //   })
        // );
        // await fetchRoleList();
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("err login", err);
      showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  const setTokenInSessionStorage = (data) => {
    const details = {
      tempPassword: window.btoa(data?.tempToken),
      currentUserId: data?.userId,
    };
    sessionStorage.setItem("token&userId", JSON.stringify(details));
  };

  const setTokenInSessionStorageUser = (data) => {
    const details = {
      tempPassword: data?.tempPassword,
      currentUserId: data?.currentUserId,
    };
    sessionStorage.setItem("token&userId", JSON.stringify(details));
  };

  const onForgotPasswordClick = async (username) => {
    try {
      const param = {
        username: username,
      };
      setLoading(true);
      const response = await GenerateTokenService(param);
      if (response) {
        setTokenInSessionStorage(response);
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };
  const onChangeCaptcha = async (value) => {
    try {
      setCaptValue(value);
      if (value) {
        setIsCaptchaCheck(true);
        // setCaptValue(value);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //on user onboarding
  const onUserOnboard = async (username) => {
    try {
      const param = {
        username: username,
      };
      setLoading(true);
      const response = await GenerateTokenUserOnBoard(param);
      if (response) {
        setTokenInSessionStorageUser(response.data);
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" sx={{ mt: 8 }}>
        <Paper elevation={3} sx={{ height: 400, width: 450 }}>
          {/* <img src={logo} alt="logo" style={{ marginBottom: "20px" }} /> */}
          <div className="logoContainer" style={{ marginBottom: "0px" }}>
            <img src={logo} alt="reliance retail" title="pbg spare" />
            <div className="projectLogo">
              <div title="R-STP" className="navBarTitle">
                R-STP
              </div>
              <div title="Spare Part Management" className="spmsHeading">
                Reliance Spare & Technical Portal
              </div>
            </div>
          </div>
          <Typography component="h1" variant="h6" color="#003f93">
            Sign in
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box sx={{ mt: 2 }}>
              <TextField
                autoFocus
                margin="normal"
                required
                fullWidth
                label="Email Address"
                name="email"
                autoComplete="off"
                sx={{ width: 300 }}
                disabled={showPasswordField ? true : false}
                {...register("email", { required: true })}
                error={Boolean(errors?.email)}
                helperText={errors?.email?.message}></TextField>
              {showPasswordField ? (
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  label="Password"
                  name="password"
                  autoFocus
                  autoComplete="off"
                  type={showPassword ? "text" : "password"}
                  sx={{ width: 300 }}
                  {...register("password", { required: true })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setShowPassword((prevValue) => !prevValue);
                          }}>
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors?.password)}
                  helperText={errors?.password?.message}></TextField>
              ) : null}
              {showForgotPassword ? (
                <Typography align="right" sx={{ mr: 9 }}>
                  <Link
                    underline="hover"
                    color="text.primary"
                    aria-current="page"
                    to={`/resetPassword`}
                    state={{ from: location }}
                    onClick={() => onForgotPasswordClick(email)}>
                    Forgot Password?
                  </Link>
                </Typography>
              ) : (
                ""
              )}
            </Box>
            {showPasswordField ? (
              <Recaptcha
                name="captchaToken"
                id="captchaToken"
                sitekey={site_Key}
                align="center"
                onChange={onChangeCaptcha}></Recaptcha>
            ) : null}
            {!showPasswordField ? (
              <Button
                type="submit"
                onClick={handleSubmit(onProceedClick)}
                sx={{ mt: 4, mb: 2 }}
                variant="outlined">
                Proceed
              </Button>
            ) : (
              <>
                <Button
                  // type="submit"
                  onClick={onBackClick}
                  sx={{ mt: 2, mb: 2, mr: 1 }}
                  variant="outlined">
                  Back
                </Button>
                <Button
                  type="submit"
                  disabled={!isCaptchaCheck}
                  onClick={handleSubmit(onSignInClick)}
                  sx={{ mt: 2, mb: 2 }}
                  variant="outlined">
                  Sign In
                </Button>
              </>
            )}
          </form>
        </Paper>
      </Container>
      <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="xs">
        <DialogTitle
          color="error"
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>Force Login</div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleDialogClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Divider />
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 3 }}>
              <Box>
                User is already logged in somewhere else, do you wish to
                continue login here?
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box
                sx={{ display: "flex", flexDirection: "row", p: 1.5, pl: 23 }}>
                <Button
                  variant="outlined"
                  onClick={handleDialogClose}
                  sx={{ mr: 1 }}>
                  No
                </Button>
                <Button
                  type="submit"
                  onClick={() => handleContinueLogin()}
                  sx={{ mr: 1 }}
                  variant="contained"
                  className="button-primary-alt-contained">
                  Yes
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </ThemeProvider>
  );
};
export default SignIn;
